<template>
  <div class="bind-info-page">
    <van-nav-bar title="个人信息绑定" left-arrow @click-left="onClickLeft" />
    
    <van-cell-group class="form-group">
      <van-field
        v-model="form.realName"
        label="姓名"
        placeholder="请输入真实姓名"
        required
        :error-message="errors.realName"
      />
      <van-field
        v-model="form.phone"
        label="手机号"
        placeholder="请输入手机号"
        type="tel"
        required
        :error-message="errors.phone"
      />
      <van-field
        v-model="form.idCard"
        label="身份证号"
        placeholder="请输入身份证号"
        required
        :error-message="errors.idCard"
      />
    </van-cell-group>
    
    <div class="tips">
      <van-icon name="info-o" />
      <span>请填写真实信息，以便预约挂号</span>
    </div>
    
    <div class="submit-btn">
      <van-button type="primary" block :loading="loading" @click="submit">确认绑定</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BindInfo',
  data() {
    return {
      form: {
        userId: null,
        realName: '',
        phone: '',
        idCard: ''
      },
      errors: {
        realName: '',
        phone: '',
        idCard: ''
      },
      loading: false
    }
  },
  created() {
    var user = this.$tool.getUser();
    if (user && user.userId) {
      this.form.userId = user.userId;
      if (user.realName) {
        this.form.realName = user.realName;
      }
      if (user.phone) {
        this.form.phone = user.phone;
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    validate() {
      var valid = true;
      this.errors = { realName: '', phone: '', idCard: '' };
      
      if (!this.form.realName.trim()) {
        this.errors.realName = '请输入姓名';
        valid = false;
      } else if (!this.$tool.chineseValidate(this.form.realName.trim())) {
        this.errors.realName = '请输入正确的中文姓名';
        valid = false;
      }
      
      if (!this.form.phone.trim()) {
        this.errors.phone = '请输入手机号';
        valid = false;
      } else if (!this.$tool.phoneNoValidate(this.form.phone.trim())) {
        this.errors.phone = '请输入正确的手机号';
        valid = false;
      }
      
      if (!this.form.idCard.trim()) {
        this.errors.idCard = '请输入身份证号';
        valid = false;
      } else if (!this.$tool.identityCodeValid3(this.form.idCard.trim().toUpperCase())) {
        this.errors.idCard = '请输入正确的身份证号';
        valid = false;
      }
      
      return valid;
    },
    submit() {
      if (!this.validate()) {
        return;
      }
      
      this.loading = true;
      this.form.idCard = this.form.idCard.toUpperCase();
      
      this.$http.post(this.$Api.wechatBindInfo, this.form)
        .then(res => {
          this.loading = false;
          if (res.data.code === 200) {
            this.$toast.success('绑定成功');
            var user = this.$tool.getUser();
            user.realName = this.form.realName;
            user.phone = this.form.phone;
            user.idCard = this.form.idCard;
            user.isBind = true;
            this.$tool.setUser(user);
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          } else {
            this.$toast.fail(res.data.msg || '绑定失败');
          }
        })
        .catch(() => {
          this.loading = false;
          this.$toast.fail('网络错误，请重试');
        });
    }
  }
}
</script>

<style scoped>
.bind-info-page {
  background: #f5f5f5;
  min-height: 100vh;
}
.form-group {
  margin-top: 10px;
}
.tips {
  padding: 16px;
  color: #999;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.tips .van-icon {
  margin-right: 6px;
  color: #1989fa;
}
.submit-btn {
  padding: 20px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/bindInfo.vue